module.exports = __webpack_public_path__ + "static/img/course__list_1.d92385a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/courses/course__list_1.jpg
// module id = vVqK
// module chunks = 1